<template>
  <h2>{{this.$route.params.id}}</h2>
</template>

<script>
export default {

}
</script>

<style>

</style>